// extracted by mini-css-extract-plugin
export default {"buttons":"LXEXiZpg ZPndn63a"};